var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E17"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E17",
    className: "cls-2",
    points: "73 231 141 231 141 221 239 221 239 342 190 342 190 310 73 310 73 231"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E18"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E18",
    className: "cls-2",
    x: 242,
    y: 231,
    width: 99,
    height: 111
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E19"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E19",
    className: "cls-2",
    x: 344,
    y: 231,
    width: 121,
    height: 111
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E5"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E5",
    className: "cls-2",
    x: 576,
    y: 231,
    width: 70,
    height: 111
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E6"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E6",
    className: "cls-2",
    x: 649,
    y: 231,
    width: 98,
    height: 111
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "E7"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E7",
    className: "cls-2",
    points: "751 221 849 221 849 231 917 231 917 310 801 310 801 342 751 342 751 221"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "E8"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E8",
    className: "cls-2",
    points: "804 313 917 313 917 405 804 405 804 371 782 371 782 345 804 345 804 313"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "E9"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E9",
    className: "cls-2",
    points: "917 409 917 486 849 486 849 499 751 499 751 374 801 374 801 409 917 409"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "E10"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E10",
    className: "cls-2",
    points: "747 381 747 486 649 486 649 374 723 374 723 381 747 381"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "E11"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E11",
    className: "cls-2",
    points: "646 374 646 486 547 486 547 381 571 381 571 374 646 374"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "E12"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E12",
    className: "cls-2",
    points: "544 381 544 486 446 486 446 374 520 374 520 381 544 381"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "E13"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E13",
    className: "cls-2",
    points: "443 374 443 486 344 486 344 381 368 381 368 374 443 374"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "E14"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E14",
    className: "cls-2",
    points: "341 381 341 486 243 486 243 374 317 374 317 381 341 381"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "E15"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E15",
    className: "cls-2",
    points: "239 374 239 499 141 499 141 486 73 486 73 409 190 409 190 374 239 374"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "E16"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E16",
    className: "cls-2",
    points: "187 313 187 345 207 345 207 371 187 371 187 406 73 406 73 313 187 313"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP1 as ReactComponent };